// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__31KGf","label":"CategoryService_label__1a7-p","location":"CategoryService_location__3KqeV"};